import React from "react";
import { MapPin, Download } from "lucide-react";
import buyProPlanFormMobile from "../../../assets/img/buyProPlanFormMobile.svg";
import apple from "../../../assets/img/apple store dark icon.svg";
import android from "../../../assets/img/play store Light Icon.svg";
import tick from "../../../assets/img/tick thanku icon.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

const AddServiceAreaWebFromMobileThankYouPage = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleViewDetails = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <div
      className="custom_container padding_top manage-dashboard-screen"
      style={{ marginBottom: 40 }}
    >
      <div className="pro-welcome">
        <div className="pro-welcome-head">
          <div className="phone-icon">
            <img src={buyProPlanFormMobile} alt="buyProPlanFormMobile" />
          </div>

          <h1 className="title">Purchase Successful!</h1>
          <p className="subtitle">Service Areas Added</p>
        </div>
        <div className="pro-welcome-secound-sec">
          <div className="next-step">
            <div className="next-step-header">
              <MapPin className="icon" size={20} />
              <h2>Next Step: Add Your Locations</h2>
            </div>
            <p className="next-step-text">
              To add or edit your service area locations, please use our mobile
              app for the best experience.
            </p>
          </div>

          <div className="features-section">
            <h3 className="features-title">Why use the mobile app ?</h3>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={tick} alt="tick" width={25} height={25} />
              </div>
              <div className="feature-content">
                <h4>Interactive Map Interface</h4>
                <p>
                  Easily select and visualize your service on an interactive map
                </p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon ">
                <img src={tick} alt="tick" width={25} height={25} />
              </div>
              <div className="feature-content">
                <h4>GPS Location Services</h4>
                <p>Precise location detection and radius configuration</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                <img src={tick} alt="tick" width={25} height={25} />
              </div>
              <div className="feature-content">
                <h4>Manage On-the-Go</h4>
                <p>Update your service areas anytime, anywhere</p>
              </div>
            </div>
          </div>

          <div className="download-section">
            <Download className="download-icon" size={24} />
            <h3>Download Our Mobile App</h3>
            <p>Available on iOS - Android coming soon</p>

            <div className="store-buttons">
              <button className="store-btn app-store"   onClick={() => window.open("https://apps.apple.com/us/app/simplerenovate-for-pros/id6754059537", "_blank")}>
                <img src={apple} alt="App Store" />
                <div className="store-text">
                  <span className="store-label">App Store</span>
                </div>
              </button>

              <button className="store-btn play-store disabled">
                <div className="play-icon">
                  <img src={android} alt="Play Store" />
                </div>
                <div className="store-text">
                  <span className="store-label">Play Store</span>
                  <span className="store-status">Coming Soon</span>
                </div>
              </button>
            </div>
          </div>

          <button
            className="cta-button"
            onClick={() => {
              handleViewDetails();
              navigate("/manage-dashboard");
            }}
          >
            I'll Do This Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddServiceAreaWebFromMobileThankYouPage;
